import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { checkPromoCode, resetPromoCode } from "../../redux/actions";
import { Button } from "../../components";
import { InvalidCross } from "../../utils";

import { PromoWrapper, PromoContainer, PromoCross, PromoError, PromoInput, PromoSuccessMessage } from "./styles";

const mapStateToProps = state => ({
  promo: state.promo,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  checkCodeOnSubmit: checkPromoCode,
  removePromoInfo: resetPromoCode,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class PromoBox extends Component {
  static propTypes = {
    promo: PropTypes.instanceOf(Object),
    checkCodeOnSubmit: PropTypes.func,
    removePromoInfo: PropTypes.func,
    disabled: PropTypes.bool,
  };

  state = {
    value: '',
  };

  handleUserInput = evt => {
    const { removePromoInfo } = this.props;
    const { target } = evt;
    const { value } = target;
    if(value.length === 0) {
      removePromoInfo();
    }
    this.setState({ value: value.toUpperCase() });
  };

  handleSubmit = evt => {
    evt.preventDefault();
    const { value } = this.state;
    const { checkCodeOnSubmit } = this.props;

    checkCodeOnSubmit(value);
  };

  render() {
    const { handleUserInput, handleSubmit } = this;
    const { value } = this.state;
    const { promo, disabled } = this.props;
    const { status, message, info } = promo;

    return (
      <PromoWrapper>
        <PromoContainer onSubmit={handleSubmit}>
          <PromoInput
            disabled={disabled}
            placeholder="Promo code"
            name="promoCode"
            value={value}
            onChange={handleUserInput}
            isInvalid={status === 'fail'}
          />
          <Button theme="secondary" htmlType="submit" disabled={status === 'fetching'}>Ok</Button>
        </PromoContainer>
        {status === 'fail' && (
          <Fragment>
            <PromoError>{message}</PromoError>
            <PromoCross>
              <InvalidCross color="#ff6f5a" />
            </PromoCross>
          </Fragment>
        )}
        {status === 'success' && (
          <PromoSuccessMessage>
            {info.isEgift && 'Gift card has been applied!'}
            {info.isReferal && 'Credit has been applied!'}
            {info.isPromo && !info.isDouble && 'Successfully applied promo!'}
            {info.isDouble && ''}
          </PromoSuccessMessage>
        )}
      </PromoWrapper>
    );
  }
}

export default PromoBox;
